import webApi from './webApi'
import { ApiClient } from './ApiClient'
import { IIncidentsData } from '../types/Incidents/IIncidentTypes'
const GetIncidents = async (
  apiClient: ApiClient,
  searchType: string,
  searchString: string,
  pageNumber: number
): Promise<IIncidentsData> => {
  const response = await webApi.get<IIncidentsData>(apiClient, {
    url: `/api/incidents`,
    params: {
      searchType: searchType,
      searchString: searchString,
      pageNumber: pageNumber
    }
  })
  return response
}

const closeIncident = async (
  apiClient: ApiClient,
  closure: any
): Promise<any> => {
  await webApi.post<any>(apiClient, {
    url: `/api/incidents/close`,
    params: [],
    body: JSON.stringify(closure),
    contentType: 'application/json'
  })
}

const reportsApi = {
  GetIncidents,
  closeIncident
}

export default reportsApi
